/*
 * @Author: your name
 * @Date: 2020-07-25 10:39:52
 * @LastEditTime: 2020-07-30 10:53:56
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/store/oauth.store.js
 */
export const SET_OPEN_ID = 'SET_OPEN_ID'
export const SET_UNION_ID = 'SET_UNION_ID'

const oauthStore = {
  namespaced: true,
  state: {
    openId: null,
    unionId: null
  },
  mutations: {
    [SET_OPEN_ID](state, openId) {
      state.openId = openId
    },
    [SET_UNION_ID](state, unionId) {
      state.unionId = unionId
    }
  }
}

export default oauthStore
